import { render, staticRenderFns } from "./OverviewOld.vue?vue&type=template&id=ac079070&scoped=true"
import script from "./OverviewOld.vue?vue&type=script&lang=js"
export * from "./OverviewOld.vue?vue&type=script&lang=js"
import style0 from "./OverviewOld.vue?vue&type=style&index=0&id=ac079070&prod&scoped=true&lang=less"
import style1 from "./OverviewOld.vue?vue&type=style&index=1&id=ac079070&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac079070",
  null
  
)

export default component.exports